import { Injectable } from '@angular/core';
import {
  CreateRefundInput,
  CreateRefundMutation,
  EstimateRefundTaxesQuery,
  LoadOrderDetailsQuery,
  LoadStorefrontOrdersQuery,
  LoadUserOrdersQuery,
  OrderItemPairAttributes
} from '@queries/generated';
import { finalMap } from '@rx/final-map';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  constructor(
    private loadUserOrdersQuery: LoadUserOrdersQuery,
    private loadOrderDetailsQuery: LoadOrderDetailsQuery,
    private loadStorefrontOrdersQuery: LoadStorefrontOrdersQuery,
    private estimateRefundTaxesQuery: EstimateRefundTaxesQuery,
    private createRefundMutation: CreateRefundMutation
  ) {}

  loadUserOrders() {
    return this.loadUserOrdersQuery.watch().valueChanges.pipe(map((resp) => resp.data.orders.mine.nodes));
  }

  loadStorefrontOrders = (id: number) => {
    return this.loadStorefrontOrdersQuery
      .watch({ id })
      .valueChanges.pipe(map((resp) => resp.data.storefronts.findById.orders.nodes));
  };

  findById = (id: number) => {
    return this.loadOrderDetailsQuery.watch({ id }).valueChanges.pipe(map((resp) => resp.data.orders.findById));
  };

  estimateRefundTaxes = (orderId: number, orderItems: OrderItemPairAttributes[], refundShipping: boolean) => {
    return this.estimateRefundTaxesQuery
      .watch({ orderId, orderItems, refundShipping })
      .valueChanges.pipe(map((resp) => resp.data.taxes.estimateForRefund));
  };

  createRefund = (input: CreateRefundInput) => {
    return this.createRefundMutation
      .mutate({ input }, { refetchQueries: ['LoadStorefrontOrders', 'LoadOrderDetails'] })
      .pipe(
        map(({ data }) => data.createRefund),
        finalMap('refund')
      );
  };
}
